export enum CollectivityPartnersEnum {
    Hema = 70034,
}
